import React, { createElement } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { MicNoneOutlined, PlaceOutlined, PersonOutlineOutlined } from '@mui/icons-material';
import { ReactComponent as VideoCamOutlined } from '../../shared/icons/VideoCamOutlined.svg';
import MediaImageIcon from '../icons/icons-revamp/media_image';
import TemplateIcon from '../icons/icons-revamp/template';
import DocumentIcon from '../icons/icons-revamp/document';
import CallIcon from '../icons/icons-revamp/calls';
import { MessageTypesEnum } from '../../modules/home/v1/typings/message-types';

const ICON_SIZE = 16;
const ICON_COLOR = '#616161';

const BASE_ICON_SX: SxProps<Theme> = {
  width: ICON_SIZE,
  height: ICON_SIZE,
  '& svg': {
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
};

const PATH_STROKE_SX: SxProps<Theme> = {
  '& path': {
    stroke: ICON_COLOR,
  },
};

type IconConfig = {
  Icon: React.ElementType;
  sx?: SxProps<Theme>;
};

const MESSAGE_ICON_MAP: Partial<Record<MessageTypesEnum, IconConfig>> = {
  [MessageTypesEnum.IMAGE]: {
    Icon: MediaImageIcon,
    sx: PATH_STROKE_SX,
  },
  [MessageTypesEnum.VIDEO]: {
    Icon: VideoCamOutlined,
  },
  [MessageTypesEnum.AUDIO]: {
    Icon: MicNoneOutlined,
    sx: PATH_STROKE_SX,
  },
  [MessageTypesEnum.DOCUMENT]: {
    Icon: DocumentIcon,
    sx: PATH_STROKE_SX,
  },
  [MessageTypesEnum.CONTACTS]: {
    Icon: PersonOutlineOutlined,
  },
  [MessageTypesEnum.LOCATION]: {
    Icon: PlaceOutlined,
  },
  [MessageTypesEnum.TEMPLATE]: {
    Icon: TemplateIcon,
    sx: PATH_STROKE_SX,
  },
  [MessageTypesEnum.CALL]: {
    Icon: CallIcon,
    sx: PATH_STROKE_SX,
  },
};

type MessageIconProps = {
  messageType: MessageTypesEnum;
};

export const MessageIcon: React.FC<MessageIconProps> = ({ messageType }) => {
  const config = MESSAGE_ICON_MAP[messageType];
  if (!config) return null;

  const { Icon, sx: iconSx } = config;
  const mergedSx: SxProps<Theme> = Array.isArray(iconSx)
    ? [BASE_ICON_SX, ...iconSx]
    : iconSx
    ? [BASE_ICON_SX, iconSx]
    : BASE_ICON_SX;

  return createElement(
    Box,
    {
      sx: mergedSx,
    },
    createElement(Icon, {})
  );
};
